import Vue from 'vue'
import App from './App.vue'
import router from './router'
import DashboardPlugin from './plugins/dashboard-plugin';
import vSelect from 'vue-select'
import flatpickr from 'flatpickr'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'

import './plugins/axios'
import './plugins/vue-mask'
import './plugins/slimdialog'
import './plugins/vuemodal'
import './plugins/vue-numeric'
import "bootstrap"
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Import BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(IconsPlugin) // Opcional: Plugin de ícones BootstrapVue

// Localiza todos os campos de data (flatpickr) para pt-BR
flatpickr.localize(Portuguese);

Vue.config.productionTip = false
Vue.use(DashboardPlugin);
Vue.component('v-select', vSelect)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
